// extracted by mini-css-extract-plugin
export default {"intro":"AllProducts_intro__tYaaw","search":"AllProducts_search__AeBJ9","allProduct-container":"AllProducts_allProduct-container__bbiGF","icons":"AllProducts_icons__ERHCH"};